import * as moment from 'moment';
import * as ko from "knockout";
import * as fs from 'fs';
import { RNSAPI } from "../../api";
import { Postbox, PostboxPaging } from '../postbox/postbox';
export class DataTablePagingViewModel {
    numberOfPages: ko.Computed<number>;
    stars = ko.observable(false);
    icons = ko.observable("");
    filter = ko.observable('');
    antiFilter = ko.observable('');
    tooltips = ko.observableArray([]);
    resetpadleft = ko.observable(false);
    pageCounter = ko.observable(0);
    isFTW = ko.observable(false);
    AllReferate = ko.observableArray([]);
    OutlookAccounts = ko.observableArray([]);
    Instances = ko.observableArray([]);
    tableParameters = ko.observable();
    tableData: ko.Observable<any>;
    Page1 = ko.observable(1);
    Page2 = ko.observable(2);
    Page3 = ko.observable(3);
    Page4 = ko.observable(4);
    Page5 = ko.observable(5);
    currentPages = ko.observableArray([1, 2, 3, 4, 5]);
    selectedElement = ko.observable(null);
    previous = () => {
        this.tableParameters().page(Math.max(0, this.tableParameters().page() - 1));
        this.updateNumbers();
    };
    first = () => {
        this.tableParameters().page(0);
        this.updateNumbers();
    };
    next = () => {
        this.tableParameters().page(Math.min(this.numberOfPages() - 1, this.tableParameters().page() + 1));
        this.updateNumbers();
    };
    last = () => {
        this.tableParameters().page(this.numberOfPages() - 1);
        this.updateNumbers();
    };
    direct(pagenr: number) {
        this.tableParameters().page(pagenr - 1);
        this.updateNumbers();
    }
    sort = (column: any) => {
        if (column.sortable) {
            if (ko.toJS(this.tableParameters().orderBy) !== column.columnHeader)
                this.tableParameters().orderBy(column.columnHeader);
            else
                this.tableParameters().sortAsc(!this.tableParameters().sortAsc());
        }
    };
    addCaret = (column: any) => {
        if (ko.toJS(this.isFTW) || !ko.toJS(column.sortable))
            return column.columnHeader;
        if (this.tableParameters().orderBy() == column.columnHeader && this.tableParameters().sortAsc())
            return '<span class="fa fa-fw fa-sort-up"></span>' + column.columnHeader;
        else if (this.tableParameters().orderBy() == column.columnHeader && !this.tableParameters().sortAsc())
            return '<span class="fa fa-fw fa-sort-down"></span>' + column.columnHeader;
        return '<span class="fa fa-fw fa-sort"></span>' + column.columnHeader;
    };
    updateNumbers = () => {
        if (ko.toJS(this.tableParameters().page()) < 3 || ko.toJS(this.numberOfPages) <= 5) {
            this.Page1(1);
            this.Page2(2);
            this.Page3(3);
            this.Page4(4);
            this.Page5(5);
        }
        else if (ko.toJS(this.tableParameters().page()) >= 3 && ko.toJS(this.tableParameters().page()) < ko.toJS(this.numberOfPages() - 2)) {
            this.Page1(this.tableParameters().page() - 1);
            this.Page2(this.tableParameters().page());
            this.Page3(this.tableParameters().page() + 1);
            this.Page4(this.tableParameters().page() + 2);
            this.Page5(this.tableParameters().page() + 3);
        }
        else if (ko.toJS(this.tableParameters().page()) >= ko.toJS(this.numberOfPages() - 2)) {
            this.Page1(this.numberOfPages() - 4);
            this.Page2(this.numberOfPages() - 3);
            this.Page3(this.numberOfPages() - 2);
            this.Page4(this.numberOfPages() - 1);
            this.Page5(this.numberOfPages());
        }
    };
    executeAction = (elem: any, handler: any) => {
        if (handler.selectable) {
            this.selectedElement(elem);
        }
        handler.action();
    };
    newDeadlineReport = async () => {
        $('#reportDeadlineModal').modal('show');
        let start = (<HTMLInputElement>document.getElementById("rStartDate")).value;
        let end = (<HTMLInputElement>document.getElementById("rEndDate")).value;
        (<HTMLInputElement>document.getElementById("startRepDeadline")).value = start;
        (<HTMLInputElement>document.getElementById("endRepDeadline")).value = end;
    };
    newDailyDeadlineReport = async () => {
        $('#reportDailyDeadlineModal').modal('show');
        (<HTMLInputElement>document.getElementById("dailyReportDate")).value = moment().format("YYYY-MM-DD");
    };
    newLeadpartnerDeadlineReport = async () => {
        $('#reportLeadpartnerDeadlineModal').modal('show');
        let start = (<HTMLInputElement>document.getElementById("rStartDate")).value;
        let end = (<HTMLInputElement>document.getElementById("rEndDate")).value;
        (<HTMLInputElement>document.getElementById("startRepDeadline")).value = start;
        (<HTMLInputElement>document.getElementById("endRepDeadline")).value = end;
    };
    openAddressModal(type) {
        Postbox.publisher().publish(type, 'clearAddressModal');
        $('#allAddressModal').modal('show');
    }
    newAppointment = async () => {
        Postbox.publisher().publish("", "FillNewAppointmentDataWithID");
        $("#AppointmentTFWmodal").modal("show");
    };
    pickCase = async () => {
        $('#modal').modal('show');
    };
    hasColumnAction = (parent: any, data: any) => parent.columnActions && parent.columnActions[data];
    hasTooltip = (parent: any, data: any) => parent.columnTooltips && parent.columnTooltips[data];
    hasIncludes = (parent: any, data: any) => {
        const found = this.tooltips().find(item => parent.originalObj[item.name] && item.col === data);
        let result;
        if (found && parent.originalObj[found.name]) {
            if (data === "subject") {
                if (this.isNotfrist(parent.originalObj.TypeId))
                    result = 'Notfrist';
            }
        }
        return result;
    };
    reasonChanged = (parent: any, data: any) => {
        const found = this.tooltips().find(item => parent.originalObj[item.name] && item.col === data);
        let result;
        if (found && parent.originalObj[found.name]) {
            if (data === "subject") {
                if (parent.originalObj.OldDeadlineReasonName !== '')
                    result = 'Zuvor ' + parent.originalObj.OldDeadlineReasonName;
            }
        }
        return result;
    };
    isDeletedEntry = (parent: any) => {
        let result = false;
        if (parent.originalObj) {
            if (parent.originalObj.IsDeleted) {
                if (parent.originalObj.IsDeleted === true) {
                    result = true;
                }
            }
        }
        return result;
    };
    isInactiveEntry = (parent: any) => {
        let result = false;
        if (parent.Inactive) {
            if (parent.Inactive === true) {
                result = true;
            }
        }
        return result;
    };
    isRemoteEntry = (parent: any) => {
        let result = "";
        try {
            if (parent.originalObj) {
                if (parent.originalObj.RemoteType !== undefined) {
                    result = parent.originalObj.RemoteType;
                }
            }
        }
        catch { }
        return result;
    };
    isNotfrist(TypeId: string) {
        switch (TypeId) {
            case "AV":
                return true;
            case "B":
                return true;
            case "ER":
                return true;
            case "ES":
                return true;
            case "NZ":
                return true;
            case "R":
                return true;
            case "SB":
                return true;
            case "RV":
                return true;
            case "We":
                return true;
            case "EP":
                return true;
            case "WK":
                return true;
            case "GE":
                return true;
            case "EA":
                return true;
            case "Er":
                return true;
            case "WA":
                return true;
            default:
                return false;
        }
    }
    postprocess = (elements: Array<HTMLElement>) => {
        for (let element of elements) {
            if (element.classList && element.classList.contains("tooltip-container")) {
                $(element).tooltip();
                break;
            }
        }
    };
    clearFilter() {
        this.tableParameters().filter("");
        this.tableParameters().antifilter("");
    }
    checkStars = (color: string) => {
        if (color == "red") {
            this.icons("fa-circle text-danger");
            return true;
        }
        if (color == "green") {
            this.icons("fa-circle text-success");
            return true;
        }
        if (color == "yellow") {
            this.icons("");
            return true;
        }
        if (color == "new") {
            this.icons("");
            return true;
        }
        if (color == "complete") {
            this.icons("");
            return true;
        }
        if (color == "server") {
            this.icons("");
            return true;
        }
        if (color == "stopped") {
            this.icons("");
            return true;
        }
        if (color == "deleted") {
            this.icons("");
            return true;
        }
        if (color == "nonSubmission") {
            this.icons("");
            return true;
        }
        if (color == "missed") {
            this.icons("");
            return true;
        }
        else {
            return false;
        }
    };
    async getReferate() {
        let res = (await RNSAPI.getReferate()).Payload.Units;
        res = res.filter(r => r.Id !== '');
        this.AllReferate(res);
        this.tableData().updateData(true);
    }
    async getOutlookAccounts() {
        let res = (await RNSAPI.getOutlook()).Payload.OutlookAccounts;
        this.OutlookAccounts(res);
    }
    async getData() {
        await this.getOutlookAccounts();
        await this.getReferate();
    }
    selectEntry = (obj, event) => {
        if (ko.toJS(this.tableParameters().activeSelection)) {
            if ($(event.target.parentElement).hasClass("active")) {
                this.selectionPick(obj);
            }
            else {
                $("#dataActiveTable tr").removeClass("active");
                $(event.target.parentElement).addClass("active");
            }
        }
    };
    selectionPick(obj) {
        let hasSelection = obj.actionHandlers.filter((o) => o.isSelectionEvent === true);
        if (hasSelection.length === 1) {
            hasSelection[0].action();
        }
    }
    ;
    toUnwrapped(): UnwrappedTableParameters {
        return ko.toJS(this.tableParameters);
    }
    constructor(params) {
        this.tableParameters = params.tableParameters;
        this.tableData = params.tableData;
        if (ko.toJS(this.tableParameters().showCaseViewButton) === true || ko.toJS(this.tableParameters().isInbox) === true) {
            if (ko.toJS(this.tableParameters().isInbox) === true) {
                this.tableParameters().start(ko.toJS(moment().format("YYYY-MM-DD")));
                this.tableParameters().end(ko.toJS(moment().format("YYYY-MM-DD")));
            }
            this.getData();
        }
        if (ko.toJS(this.tableParameters().isMailbox) === true) {
            this.Instances(ko.toJS(params.instances));
        }
        ko.computed(() => {
            const unwrapped = this.toUnwrapped();
            if (this.tableData().updateData()) {
                PostboxPaging.publisher().publish((this.tableParameters), this.tableParameters().postboxName);
            }
        });
        if (this.tableParameters().columns[0].columnHeader == "status")
            this.stars(true);
        this.resetpadleft = params.resetpadleft;
        if (params.tooltips) {
            this.tooltips = params.tooltips;
        }
        if (params.isFTW)
            this.isFTW(true);
        this.tableData().totalCount.subscribe(() => this.tableParameters().page(0));
        this.numberOfPages = ko.computed({
            owner: this,
            read: () => {
                return Math.ceil(this.tableData().totalCount() / +this.tableParameters().pageSize());
            }
        });
        this.numberOfPages.subscribe(newNumberOfPages => this.tableParameters().page(Math.max(0, Math.min(newNumberOfPages - 1, this.tableParameters().page()))));
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    }
}
export interface Color {
    color: string;
    "background-color": string;
}
export interface UnwrappedTableParameters {
    page: number;
    pageSize: string;
    activeSelection: boolean;
    hasActions: boolean;
    columns: string[];
    columnHeaders: string[];
    emptyMessage: string;
    count: number;
}
export class IntermediateListItem {
    stars: any;
    entryType: string;
    entryTypeName: string;
    date: string;
    dateObj: moment.Moment;
    subject: string;
    number: string;
    originalObj: any;
    actionHandlers: any;
    color: Color;
    rubrum: string;
    entryType1: string;
    SB: string;
    note: string;
    ref: string;
    fka: string;
    instance: string;
    instanceId: string;
    currentFVA: string;
    revision: number;
    constructor(stars: any, entryType: string, entryTypeName: string, date: string, subject: string, number: string, originalObj: any, actionHandlers?: any, color?: Color, rubrum?: string, sb?: string, note?: string, ref?: string, fka?: string, instance?: string, instanceId?: string, currentFVA?: string, revision?: number) {
        this.stars = stars;
        this.entryType = entryType;
        this.entryTypeName = entryTypeName;
        this.dateObj = moment.utc(date);
        this.date = this.dateObj.format("DD.MM.YYYY");
        this.subject = subject;
        this.number = number;
        this.originalObj = originalObj;
        this.actionHandlers = actionHandlers || [{ name: "Vorschau", action: () => { alert("Aktion für Typ: " + this.entryType); } }];
        this.color = color;
        this.rubrum = rubrum;
        this.note = note;
        this.SB = sb;
        this.ref = ref;
        this.fka = fka;
        this.instance = instance;
        this.instanceId = instanceId;
        this.currentFVA = currentFVA;
        this.revision = revision;
    }
}
;
var html = fs.readFileSync(__dirname + '/dataTablePaging.html', 'utf8');
ko.components.register("data-table-paging", {
    viewModel: DataTablePagingViewModel,
    template: html
});
